<template>
  <div class="content" v-loading="loading">
    <h3 class="headerTitle">申请售后</h3>
    <el-divider content-position="left">退款信息</el-divider>
    <div class="orderData">
      <div>订单号：{{ myRefundInfo.orderNumber }}</div>
      <div>售后类型：{{myRefundInfo.status >= 2 ? '退货退款' : '退款'}}</div>
    </div>
    <div class="good-item" v-for="goodItem in myRefundInfo.orderCommodityList" :key="goodItem.bxysid">
      <el-image :src="goodItem.specificationImg || goodItem.commodityImage" class="good-cover">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <div class="good-info">
        <p class="good-name">{{ goodItem.commodityName }}</p>
        <p class="good-attr">{{ goodItem.attributes }}</p>
        <p class="good-price">{{ goodItem.buyprice | decimal }} × {{ goodItem.num || 1 }}</p>
      </div>
    </div>
    <el-divider content-position="left">售后信息</el-divider>
    <el-form :rules="rules" ref="refundForm" :model="refundForm" label-width="80px">
      <el-form-item label="退款原因" prop="reason">
        <el-select v-model="refundForm.reason" placeholder="请选择">
          <el-option v-for="item in reasonList" :key="item.dictValue" :label="item.dictLabel"
                     :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="退款金额" prop="amount">
        <el-input readonly v-model="refundForm.amount"></el-input>
      </el-form-item>
      <el-form-item label="退款说明" prop="description">
        <el-input type="textarea" v-model="refundForm.description" placeholder="输入退款说明"></el-input>
      </el-form-item>
      <el-form-item label="退款凭证" prop="proof">
        <el-upload name="files" class="avatar-uploader"
          :action="`${$baseUrl}/custom/xunyou/api/common/upload`" :show-file-list="false"
          :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="refundForm.proof" :src="urlImg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitApply">申请退款</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {addbackMoney, getDictData} from '../../../api/xunyou'

export default {
  data() {
    return {
      loading: false,
      urlImg: '', // 用来图片预览的
      refundForm: {
        reason: '',
        amount: 0,
        description: '',
        proof: '',
      },
      reasonList: [],
      rules: {
        reason: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        amount: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        description: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        proof: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo;
    },
    myRefundInfo () {
      return JSON.parse(sessionStorage.getItem('myRefundInfo'));
    }
  },
  mounted() {
    this.initRefundAmount();
    this.backReason();
  },
  methods: {
    // 初始化退款金额
    initRefundAmount () {
      const amount = this.myRefundInfo.orderCommodityList.reduce((res, cur) => {
        return res += (cur.balancePay + cur.otherPay);
      }, 0);
      this.refundForm.amount = amount.toFixed(2);
    },
    //   查询退款原因
    backReason() {
      getDictData({ key: 'b_xy_deal_after_sale_reason' }).then(res => {
        if (res.code === 0) {
          this.reasonList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    submitApply() {
      this.$refs.refundForm.validate((valid) => {
        if (valid) {
          const req = {
            uid: this.userInfo.userId,
            oid: this.myRefundInfo.oid,
            type: 1, // 申请类型 1:退款，2.退换
            afterType: this.myRefundInfo.voucherPay > 0 ? 'ORDER' : 'GOOD',
            applyAmount: this.refundForm.amount,
            reason: this.refundForm.reason,
            returnType: this.myRefundInfo.status >= 2 ? 1 : 2, // 退货类型 1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
            remarks: this.refundForm.description,
            remarksImg: this.refundForm.proof,
            goodList: this.myRefundInfo.orderCommodityList.map(ele => ({ bxysid: ele.bxysid }))
          }
          this.loading = true;
          addbackMoney(req).then(res => {
            console.log('退款申请：', res);
            this.loading = false;
            if (res.code === 0) {
              this.$router.replace('/refund');
              sessionStorage.removeItem("myRefundInfo");
            } else {
              this.$message.error(res.msg);
            }
          }).catch(err => {
            this.$message.error('提交失败，请稍后再试！')
          })
        }
      });
    },
    //   退款凭证上传
    handleAvatarSuccess(res, file) {
      console.log('上传结果：', res);
      if (res.code === 0) {
        this.refundForm.proof = res.url;
      }
      this.urlImg = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    }
  }

};
</script>

<style scoped lang="less">
.headerTitle {
  font-size: 20px;
  color: #666;
}
.orderData{
  margin: 20px 0;
  background-color: #f5f5f5;
  padding: 15px;
}
.avatar-uploader{
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
}

.good-item{
  display:flex;
  justify-content: flex-start;
  align-items: center;
  .good-cover{
    width: 70px;
    height: 70px;
    margin-right: 10px;
    border-radius: 5px;
  }
  .good-info{
    flex: 1;
  }
  .good-name{
    font-size: 14px;
    font-weight: 500;
  }
  .good-attr{
    color: var(--main-theme-color);
    font-size: 12px;
  }
  .good-price{
    margin-top: 10px;
  }
}

/deep/ .el-form{
  width: 500px;
  .el-select{
    width: 100%;
  }
}

</style>







// WEBPACK FOOTER //
// src/views/myOrder/customerService/myRefund.vue